import React from 'react';
import TelaEntregas from '../components/TelaEntregas';

export default function EntregasProdutosDropdown() {
  return <TelaEntregas tipo="produto" />;
}
